import PropTypes from 'prop-types';
import React from 'react';
import ViewDetailsButton from './ViewDetailsButton';

export default function AddButton(props) {
    const handleClick = (e) => {
        e.stopPropagation();
        props.action();
    };

    if (props.isAvailable) {
        return (
            <button type="button" className="sg-button-primary appActions-add" onClick={handleClick}>
                {props.isAdmin ? 'Enable Integration' : 'Add'}
            </button>
        );
    }

    return <ViewDetailsButton {...props} />;
}

AddButton.propTypes = {
    action: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
    isAvailable: PropTypes.bool,
};
